export default "__VITE_ASSET__EBrWml8g__"